import React from 'react';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import _ from 'lodash';
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

import { MenuItem } from '@tassomutuo-backoffice/types';
import configEnv from '../../../../config/config';

interface IProps {
  menuItem: MenuItem;
  prodMenuItem: MenuItem | undefined;
  onDeleteClick: () => void;
  onEditClick: () => void;
}

const MenuItemCard = ({
  menuItem,
  prodMenuItem,
  onDeleteClick,
  onEditClick,
}: IProps) => {
  const renderTassoStatus = () => {
    if (!configEnv.isStage) {
      return null;
    }

    if (_.isEqual(prodMenuItem, menuItem)) {
      return (
        <Tooltip title="Produzione sincronizzata">
          <CheckCircleIcon color="success" />
        </Tooltip>
      );
    }

    if (!prodMenuItem) {
      return (
        <Tooltip title="NON in produzione">
          <ReportIcon color="error" />
        </Tooltip>
      );
    }

    return (
      <Tooltip title="Produzione non aggiornata">
        <WarningIcon color="warning" />
      </Tooltip>
    );
  };

  return (
    <Box sx={{ bgcolor: 'white', p: 2, m: 4 }}>
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Typography variant="h5" fontWeight="bold">
            {menuItem.name}
          </Typography>
          {menuItem?.page?.path && (
            <Typography>({menuItem?.page?.path})</Typography>
          )}
        </Box>
        {configEnv.isStage && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {renderTassoStatus()}
            <IconButton onClick={onEditClick}>
              <EditIcon />
            </IconButton>
            <IconButton onClick={onDeleteClick}>
              <DeleteIcon />
            </IconButton>
          </Box>
        )}
      </Box>
      {menuItem.subItems && menuItem.subItems.length > 0 && (
        <List dense>
          {menuItem.subItems.map((i) => (
            <ListItem key={i.id}>
              <ListItemIcon sx={{ minWidth: '20px' }}>
                <RemoveIcon sx={{ fontSize: '15px' }} />
              </ListItemIcon>
              <ListItemText primary={i.name} secondary={`(${i?.page?.path})`} />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};

export default MenuItemCard;
